import NiceModal from '@ebay/nice-modal-react';

import { CompleteEmailActionSheetController } from './complete-email-action-sheet.controller';

export const completeEmailActionSheetModalId = 'complete-email-action-sheet' as const;
const CompleteEmailActionSheetModal = NiceModal.create(CompleteEmailActionSheetController);
NiceModal.register(completeEmailActionSheetModalId, CompleteEmailActionSheetModal);
